<template>
    <div :class="{ 'transform -translate-y-full' : !showModal }" class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50 bg-gray-800 bg-opacity-75 transition ease-in-out duration-200">
        <div class="relative w-full max-w-md max-h-full">
            <div class="shadow-lg bg-white border-2 border-black border-solid rounded-md p-3">
                <div class="flex items-start justify-between border-b pb-3 rounded-t dark:border-gray-600">
                    <h3 class="flex gap-2 items-center text-xl font-semibold text-gray-900 dark:text-white">
                        For Renewal
                    </h3>
                    <button @click="$emit('onClose')" class="bg-red-500 w-8 h-8 flex items-center justify-center rounded-full">
                        <SvgIcons iconname="x-mark"></SvgIcons>
                    </button>
                </div>
                <div class="mt-5">
                    <LoadQueryVue :query="'Dashboard/get-client'" :variables="null" v-slot="{data}">
                        <div v-if="data!=null" class="h-96 overflow-y-scroll">
                            <TableTemplate v-slot="{table, thead, th, tr, td}">
                                <table :class="table">
                                    <thead :class="thead">
                                        <th :class="th">Name</th>
                                        <th :class="th">Date Start</th>
                                        <th :class="th">Date End</th>
                                    </thead>
                                    <tbody>
                                        <tr :class="tr" v-for="item,index in data.forerenewals" :key="index">
                                            <td :class="td">{{ item.firstName +" "+ item.lastName }}</td>
                                            <td :class="td">{{formatshortdate(item.startDate)}}</td>
                                            <td :class="td">{{formatshortdate(item.endDate)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </TableTemplate>
                        </div>
                    </LoadQueryVue>
                    <div class="flex justify-end mt-5">
                        <InputTemplateVue v-slot="{button}">
                            <button @click="exporttoexcel()" class="bg-green-600" :class="button">EXPORT TO EXCEL</button>
                        </InputTemplateVue>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SvgIcons from '../SvgIcons.vue';
import LoadQueryVue from '../LoadQuery.vue';
import TableTemplate from '../TableTemplate.vue';
import InputTemplateVue from '../InputTemplate.vue';
import membership from '@/mixin/membership';

export default {
    mixins:[membership],
    components: {
        SvgIcons,
        LoadQueryVue,
        TableTemplate,
        InputTemplateVue
    },
    props: {
        showModal: Boolean
    },
    methods:{
        async exporttoexcel(){
            await this.axios({
                url: "Dashboard/export-forrenewal",
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'ForRenewalList.xls');
                    document.body.appendChild(fileLink);

                    fileLink.click();
            });
        }
    }
}
</script>